import { Component, Vue } from 'vue-property-decorator';

import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';
import { ImageWidths } from '@/common/interfaces/SizeBreakpoints';

const TemplateLoadingProps = Vue.extend({
  props: {
    loaded: Boolean,
  },
  components: {
    ResponsiveImageRatio,
  },
});

@Component({})
export default class TemplateLoading extends TemplateLoadingProps {
  get imageUrl() {
    return '/Images/favicon96LEX.png';
  }

  get imageAlt() {
    return 'Lindblad Loader';
  }

  imageWidths: ImageWidths = {
    def: 448,
    sizes: {
      sm: 448,
      md: 448,
      lg: 448,
      xl: 448,
    },
  };
}
